import styled from 'styled-components';

// Semantic heading components — use these for SEO-relevant headings.
// They carry the same visual styles as their Heading* counterparts
// but render proper HTML heading tags for accessibility and SEO.

export const PageTitle = styled.h1`
  color: ${({ theme }) => theme.colors.black};
  font-size: 2rem;
  font-weight: 900;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

export const SectionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.black};
  font-size: 2rem;
  font-weight: 900;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

export const SectionTitleAccent = styled.h2`
  font-family: 'Sports College';
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 2rem;
  font-weight: 900;
`;

export const CardTitle = styled.h3`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 1.2rem;
  font-weight: 700;
`;

export const Heading1 = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 2rem;
  font-weight: 900;

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

export const Heading2 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 0.8rem;
  font-weight: 900;
`;

export const Heading3 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 1.2rem;
  font-weight: 700;
`;

export const Heading4 = styled.p`
  font-family: 'Sports College';
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 2rem;
  font-weight: 900;
`;

export const Heading5 = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.75rem;
  line-height: 32px;
  font-weight: 900;
`;

export const Heading6 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 1rem;
  font-weight: 400;
`;

export const Heading7 = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 2.2rem;
  font-weight: 600;
`;

export const Heading8 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 0.7rem;
  font-weight: 900;
`;

export const Heading9 = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: 1rem;
  font-weight: 500;
`;

export const Heading10 = styled.p`
  color: ${({ theme, color }) => (color ? color : theme.colors.white)};
  font-size: 1.375rem;
  font-weight: 500;
`;

export const Heading11 = styled.p`
  color: ${({ theme }) => theme.colors.mainBlue};
  font-weight: 700;
  font-size: 1.2rem;
`;

export const Heading12 = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.875rem;
  font-weight: 500;
`;

export const Heading13 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 4.5rem;
  font-weight: 500;
`;

export const Heading14 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 1.5rem;
  font-weight: 700;
`;

export const Heading15 = styled.p`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.375rem;
  font-weight: 500;
`;

export const Heading16 = styled.p`
  color: ${({ theme }) => theme.colors.slateGray};
  font-size: 2rem;
  font-weight: 900;
`;

export const Heading17 = styled.p`
  font-size: 1rem;
  font-weight: 500;
`;

export const Heading18 = styled.p`
  color: ${({ theme }) => theme.colors.mainBlue};
  font-size: 2rem;
  line-height: normal;
  font-weight: 900;
`;

export const Heading19 = styled.p`
  font-weight: 500;
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.codGray};
`;

export const Heading20 = styled.p`
  font-weight: 600;
  font-size: 1.05rem;
  color: ${({ theme }) => theme.colors.codGray};
`;

export const Heading21 = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 1.8rem;
  font-weight: 600;
  line-height: 1;
`;

export const Heading22 = styled.span`
  color: ${({ theme }) => theme.colors.codGray};
  font-size: 2rem;
  font-weight: 500;
  line-height: 0.7;
`;

export const Heading23 = styled.p`
  font-size: 0.85rem;
  font-weight: 500;
`;

export const Paragraph1 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 0.9rem;
  line-height: 1.5;
`;

export const Paragraph2 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 1rem;
  line-height: 1.5;
`;

export const Paragraph3 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 0.875rem;
  line-height: 2;
`;

export const Paragraph4 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.75;
`;

export const Paragraph5 = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
`;

export const Paragraph6 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 0.7rem;
  font-weight: 600;
`;

export const Paragraph7 = styled.p`
  font-weight: 500;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.codGray};
  line-height: 30px;
`;

export const Paragraph8 = styled.p`
  font-weight: 500;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.codGray};
`;

export const Paragraph9 = styled.p`
  font-weight: 500;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.raven};
  line-height: 34px;
`;

export const Paragraph10 = styled.p`
  font-family: 'Sports College';
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 1rem;
  font-weight: 300;
`;

export const Paragraph11 = styled.p`
  color: ${({ theme }) => theme.colors.mainOrange};
  font-size: 0.85rem;
  font-weight: 500;
`;

export const Paragraph12 = styled.p`
  color: ${({ theme }) => theme.colors.mainBlue};
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 1.1px;
`;

export const Paragraph13 = styled.p`
  font-weight: 300;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.codGray};
`;

export const Paragraph14 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 1.8rem;
  font-weight: 500;
`;

export const Paragraph15 = styled.p`
  font-size: 1rem;
  letter-spacing: 1.1px;
`;

export const TextLink1 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 0.8rem;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.mainOrange};
  }
`;

export const TextLink2 = styled.p`
  color: ${({ theme }) => theme.colors.raven};
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.mainOrange};
  }
`;

export const TextLink4 = styled.p`
  font-weight: 500;
  font-size: 1.375rem;
  color: ${({ theme }) => theme.colors.white};

  &:hover {
    color: ${({ theme }) => theme.colors.mainOrange};
  }
`;

export const Label1 = styled.label`
  font-weight: 500;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.wildSand};
`;

export const Label2 = styled.label`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.mainBlue};
  text-shadow: 0px 0px 2px rgba(255, 255, 255, 1);
`;

export const Label3 = styled.label`
  font-size: 0.8rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.mainBlue};
`;

export const Label4 = styled.p`
  font-weight: 500;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.codGray};
`;

export const Label5 = styled.p`
  font-weight: 600;
  font-size: 1.25rem;
  color: ${({ theme }) => theme.colors.mainOrange};

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

export const Label6 = styled.label`
  font-weight: 500;
  font-size: 1rem;
  color: ${({ theme }) => theme.colors.mineShaft};
`;

export const Label7 = styled.label`
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.white};
`;

export const Label8 = styled.label`
  font-size: 6rem;
  font-weight: lighter;
  color: ${({ theme }) => theme.colors.white};
`;

export const Label9 = styled.label`
  font-size: 4rem;
  font-weight: lighter;
  color: ${({ theme }) => theme.colors.white};
`;

export const Label10 = styled.label`
  font-size: 1rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.codGray};
`;

export const Label11 = styled.label`
  font-size: 0.75rem;
  font-weight: lighter;
  font-family: 'Frontype';
  color: ${({ theme }) => theme.colors.white};
  letter-spacing: 5px;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
`;

export const Label12 = styled.label`
  font-size: 1.4rem;
  font-weight: lighter;
  font-family: 'Frontype';
  line-height: normal;
  color: ${({ theme }) => theme.colors.white};
  letter-spacing: 5px;
  text-shadow: 2px 2px 2px rgba(0, 0, 0, 1);
`;

export const Label13 = styled.label`
  font-size: 0.8rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mainBlue};
`;

export const Label14 = styled.label`
  font-weight: 400;
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.raven};
`;

export const Label15 = styled.span`
  color: ${({ theme }) => theme.colors.codGray};
  font-size: 0.65rem;
  font-weight: 400;
`;

export const InfoCardText = styled.p`
  color: ${({ theme }) => theme.colors.codGray};
  font-size: 0.675rem;
  font-weight: 500;
  line-height: 1.6;
`;

export const Text1 = styled.text`
  font-size: 1.2rem;
  stroke: ${({ theme }) => theme.colors.mainBlue};
`;

export const Text2 = styled.p`
  color: ${({ theme }) => theme.colors.slateGray};
  font-size: 0.85rem;
  font-weight: 900;
`;

export const TextInput1 = styled.input`
  font-size: 1.4rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.mainOrange};
`;

export const Error = styled.p`
  font-weight: 100;
  color: ${({ theme }) => theme.colors.error};
`;

export const ErrorMessage = styled.p`
  color: ${({ theme }) => theme.colors.error};
  font-weight: 500;
`;

export const ErrorCode = styled.code`
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.silverChalice};
`;

// Utility typographies - small uppercase labels
export const LabelUppercase = styled.span`
  font-size: 0.75rem;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.raven};
  text-transform: uppercase;
`;

// Success colored text for positive actions/results
export const SuccessText = styled.span`
  font-weight: 500;
  color: ${({ theme }) => theme.colors.success};
`;

// Semibold blue text for values/amounts
export const ValueHighlight = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.mainBlue};
`;

export const StatValue = styled.span`
  color: ${({ theme }) => theme.colors.mainBlue};
  font-size: 2.5rem;
  font-weight: 900;
  line-height: 1;

  @media (max-width: 600px) {
    font-size: 2rem;
  }
`;

export const SmallLabel = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.raven};
`;

export const BoldLabel = styled.span`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.black};
`;

export const TableBoldText = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
`;

export const TableText = styled.span`
  font-size: 0.875rem;
`;

export const HeroTitle = styled.h1`
  color: ${({ theme }) => theme.colors.white};
  font-size: 2.6rem;
  font-weight: 800;
  line-height: 1.25;
  letter-spacing: -0.5px;

  @media (max-width: 1050px) {
    font-size: 1.8rem;
  }

  @media (max-width: 600px) {
    font-size: 1.5rem;
  }
`;

export const HeroSubtitle = styled.p`
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 1.7;

  @media (max-width: 1050px) {
    font-size: 0.95rem;
  }

  @media (max-width: 600px) {
    font-size: 0.85rem;
  }
`;
